import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { MEMBERSHIP_PLANS } from "../../constants/constants"

const UpgradeModal = ({
    show,
    customer,
    fullFreePromoCodes,
    handleClose,
    handleSubmit
}: {
    show: string
    customer: Record<string, any>
    fullFreePromoCodes?: Record<string, any>[]
    handleClose: () => void
    handleSubmit: Function
}) => {
    const { t, i18n } = useTranslation()
    const [target, setTarget] = useState("")
    const [promoCode, setPromoCode] = useState("")

    useEffect(() => {
        if (customer?.user_type === MEMBERSHIP_PLANS.PREMIUM?.toUpperCase()) {
            setTarget(MEMBERSHIP_PLANS.W)
        } else {
            setTarget("")
            setPromoCode("")
        }
    }, [customer?.user_type])

    return (
        <Modal
            show={show === "upgradeModal"}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton>
                <Modal.Title>{t("Upgrade a non-Business User")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                <Form className="form">
                    <div>
                        <p className="modal-description pb-3">
                            {t("Upgrade a non-Business User to premium or business.")}
                        </p>
                        <Row className="w-100 mb-2">
                            <Col lg={12} className="label required">
                                {t("Current Plan")}
                            </Col>
                        </Row>
                        <Row className="w-100 mb-2 px-0">
                            <Col lg={12} className="label">
                                <Form.Control
                                    className="w-100"
                                    value={MEMBERSHIP_PLANS[customer?.user_type]}
                                    readOnly
                                />
                            </Col>
                        </Row>
                        <Row className="w-100 mb-2">
                            <Col className="label required">{t("Tagret Plan")}</Col>
                        </Row>
                        <Row className="w-100 mb-2 mx-0">
                            <Col className="label px-0">
                                <select
                                    id="target"
                                    name="target"
                                    value={target}
                                    disabled={customer?.user_type === MEMBERSHIP_PLANS.PREMIUM?.toUpperCase()}
                                    onChange={(e) => setTarget(e.target.value)}
                                    className="form-control select-column">
                                    <option>--</option>
                                    {[MEMBERSHIP_PLANS.P, MEMBERSHIP_PLANS.W]?.map((plan: string) => (
                                        <option value={plan} id={`plan-${plan}`}>
                                            {plan}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                        </Row>
                        {target && target !== "" && (
                            <>
                                <Row className="w-100 mb-2">
                                    <Col className="label required">{t("Promo code")}</Col>
                                </Row>

                                <Row className="w-100 mb-2 mx-0">
                                    <Col className="label px-0">
                                        <select
                                            id="applyPromocode"
                                            name="applyPromocode"
                                            value={promoCode}
                                            onChange={(e) => setPromoCode(e.target.value)}
                                            className="form-control select-column">
                                            <option>--</option>
                                            {fullFreePromoCodes
                                                ?.filter(
                                                    (pc: Record<string, any>) =>
                                                        pc.subscription_type === target?.toLowerCase()
                                                )
                                                ?.map((promocode: Record<string, any>) => (
                                                    <option
                                                        value={promocode?.code}
                                                        id={`plan-${promocode?.name}`}>
                                                        {promocode?.code}
                                                    </option>
                                                ))}
                                        </select>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>

                <Button
                    onClick={() => {
                        handleSubmit(customer?.id, target.toLowerCase(), promoCode)
                    }}
                    disabled={target === "" || promoCode === ""}
                    className="btn btn-primary"
                    type="submit">
                    {t("Upgrade")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default UpgradeModal
